var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.formFields.tipoDocumento.label,
                  items: _vm.listaTipoDocumentos,
                  "item-text": "nombre",
                  "item-value": "id"
                },
                model: {
                  value: _vm.formFields.tipoDocumento.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.tipoDocumento, "value", $$v)
                  },
                  expression: "formFields.tipoDocumento.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaInicio.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaInicio.id
                  ),
                  id: _vm.formFields.fechaInicio.id,
                  min: _vm.fechaMinima,
                  max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                },
                model: {
                  value: _vm.formFields.fechaInicio.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                  },
                  expression: "formFields.fechaInicio.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaTermino.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaTermino.id
                  ),
                  id: _vm.formFields.fechaTermino.id,
                  max: _vm.fechaMaxima,
                  min: _vm.fechaMinimaInicio.format("YYYY-MM-DD")
                },
                model: {
                  value: _vm.formFields.fechaTermino.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaTermino, "value", $$v)
                  },
                  expression: "formFields.fechaTermino.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.formFields.estado.label,
                  items: _vm.listaEstados,
                  "item-text": "nombre",
                  "item-value": "nombre"
                },
                model: {
                  value: _vm.formFields.estado.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.estado, "value", $$v)
                  },
                  expression: "formFields.estado.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.nroDcto.label,
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.formFields.nroDcto.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.nroDcto, "value", $$v)
                  },
                  expression: "formFields.nroDcto.value"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { sm1: "", md1: "" } }, [
            _c(
              "div",
              { staticClass: "text-xs-center" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.handleBuscarClick }
                  },
                  [_c("v-icon", [_vm._v("search")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.clearFilters }
                  },
                  [_c("v-icon", [_vm._v("clear")])],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }